<template>
  <div class="sky-hc-category-select">
    <el-input
      v-model="seletedItem.name"
      readonly
      class="sky-hc-category-select__input"
      @click.native.stop="toggleDropdown"
      ><i slot="suffix" class="el-icon-arrow-down"></i
    ></el-input>
    <div class="sky-hc-category-select__dropdown" v-show="showDropdown">
      <classify-tree
        :data="data"
        :actions="actions"
        @handleTreeClick="handleTreeClick"
        :type="type"
        :activeId="activeId"
      />
    </div>
  </div>
</template>
<script>
import { Input } from 'element-ui'

import ClassifyTree from './classifyTree'

import { CATEGORY_TYPE } from '@/utils/enum'
export default {
  components: {
    ClassifyTree,
    [Input.name]: Input
  },
  name: 'ArticleCategorySelect',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    actions: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      default() {
        return CATEGORY_TYPE.ARTICLE
      }
    }
  },
  computed: {
    activeId() {
      if (this.seletedItem) {
        return this.seletedItem.id
      }
      return this.data[0] && this.data[0].children && this.data[0].children[0].id
    }
  },
  data() {
    return {
      seletedItem: {},
      showDropdown: false
    }
  },
  created() {
    const _this = this
    this.handleInitSeletedItem()
    document.documentElement.addEventListener('click', function() {
      if (_this.showDropdown) {
        _this.showDropdown = false
      }
    })
  },
  methods: {
    handleInitSeletedItem() {
      if (this.value.id || (this.data[0] && this.data[0].children)) {
        const id = this.value.id || this.data[0].children[0].id
        this.initSeletedItem(id, this.data)
      } else {
        this.seletedItem = this.data.length ? this.data[0] : {}
      }
      this.$emit('input', this.seletedItem)
    },
    initSeletedItem(id, dataArr) {
      for (let i = 0; i < dataArr.length; i++) {
        if (dataArr[i].id === id) {
          this.seletedItem = dataArr[i]
          return
        } else {
          if (dataArr[i].children && dataArr[i].children.length) {
            this.initSeletedItem(id, dataArr[i].children)
          }
        }
      }
    },
    handleTreeClick(item) {
      this.seletedItem = item
      this.$emit('input', item)
      this.showDropdown = false
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-category-select) {
  position: relative;
  z-index: 2;
  @include e(input) {
    cursor: pointer;
    input {
      cursor: pointer;
    }
  }
  @include e(dropdown) {
    width: 100%;
    position: absolute;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
